import { PROGRAM_TYPES } from 'src/constants/programs';

/**
 * SBT graphs read bottom-up (first target at the bottom), so the target axis
 * is sorted ascending when every plotted program is SBT.
 * @param {string|undefined} sortOrder - axisCategorySortOrder from the series settings
 * @param {string|undefined} sortBy - axisCategorySortBy from the series settings
 * @param {Array<string|undefined>} programTypes - types of the programs in the chart data
 * @returns {string|undefined}
 */
export default function getTargetAxisSortOrder(sortOrder, sortBy, programTypes) {
  if (sortBy !== 'targetOrder' || !programTypes.length) {
    return sortOrder;
  }
  return programTypes.every((type) => type === PROGRAM_TYPES.SBT) ? 'asc' : sortOrder;
}
